<template>
  <v-col md="12" style="padding: 0">
    <v-card
      flat
      elevation="0"
      style="
        background: white;
        border-bottom: 1.5px solid indigo;
        display: flex;
        justify-content: end;
      "
    >
      <!-- <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
        "
      >
        <v-toolbar-title class="overline"
          > <p
            style="font-size: 16px; margin: 0; font-weight: bold; color: indigo"
          >
            Manage Lot
          </p>
        </v-toolbar-title>
      </div> -->

      <div style="display: flex">
        <v-btn
          outlined
          elevation="1"
          color="indigo"
          class="indigo--text font-weight-bold ma-2"
          small
          @click="addLine"
        >
          Manual Add
        </v-btn>
        <v-btn
          outlined
          elevation="1"
          color="indigo"
          class="indigo--text font-weight-bold ma-2"
          small
          @click="randomGenerate"
        >
          Random Generate
        </v-btn>
        <v-btn
          outlined
          elevation="1"
          color="indigo"
          class="indigo--text font-weight-bold ma-2"
          small
          @click="addSequence"
        >
          Sequence Generate
        </v-btn>
        <!-- <v-btn
          small
          tile
          color="black"
          class="ma-2"
          style="color: white"
          @click="save"
        >
          Simpan
        </v-btn> -->
      </div>
    </v-card>
    <!-- ------------------------ Owned lot ---------------------------------- -->
    <v-card
      v-if="lot !== null"
      flat
      class="mx-auto"
      style="padding: 0; width: 99%; margin-top: 20px; margin-bottom: 10px"
    >
      <v-toolbar-title class="overline">
        <p
          style="
            font-size: 14px;
            margin: 0;
            padding: 5px;
            font-weight: bold;
            color: indigo;
            text-align: center;
          "
        >
          Owned LOT
        </p>
      </v-toolbar-title>
      <!-- <v-col md="3" style="padding: 0">
        <div style="padding: 0 10px">
          <v-col cols="6" style="padding: 0">
            <p
              style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
            >
              Total Aset
            </p>
          </v-col>
          <v-col cols="12" style="padding: 0">
            <v-text-field
              v-if="lot !== null"
              dense
              outlined
              readonly
              :value="lot.total_stock"
            />
          </v-col>
        </div>
      </v-col> -->
      <v-data-table
        fixed-header
        height="33vh"
        :items="lot.lot"
        :headers="headers"
        class="elevation-1 mx-auto"
        style="
          width: 100%;
          margin-bottom: 10px;
          border: 1px solid #e0e0e0;
          cursor: pointer;
        "
        :items-per-page="10"
        @click:row="rowClick"
        mobile-breakpoint="0"
      >
        <template v-slot:[`item.qty`]="{ item }">
          <div style="font-size: 12px; padding: 0; width: 60px">
            {{ item.qty }}
          </div>
        </template>
        <template v-slot:[`item.qty_used`]="{ item }">
          <v-tooltip bottom color="info">
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                v-if="item.usage.length > 0"
                @click.stop="openUsageList(item)"
              >
                <a
                  href="javascript:void(0);"
                  style="font-size: 12px; padding: 0; width: 60px"
                >
                  {{ item.qty_used }}
                </a>
              </div>
            </template>
            <span>Lihat Dokumen Pemakaian</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.current_location_name`]="{ item }">
          <div style="font-size: 12px; padding: 0; width: 210px">
            {{ item.current_company_name }} - ({{ item.current_location_name }})
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div
            :style="`font-size:12px; padding: 0; width: 50px; color:${statusColor(
              item.status
            )};`"
          >
            {{ lotStatus(item.status) }}
          </div>
        </template>
        <template v-slot:[`item.lot_no`]="{ item }">
          <div style="font-size: 12px; padding: 0; width: 90px">
            {{ item.lot_no }}
          </div>
        </template>
        <!-- <template v-slot:[`item.purchase_date`]="{ item }">
          <div style="font-size: 12px; padding: 0;  width: 70px;">
            {{ item.purchase_date }}
          </div>
        </template> -->
        <template v-slot:[`item.created_at`]="{ item }">
          <div style="font-size: 10px; padding: 0; width: 90px">
            {{ convertDate(item.created_at) }}
          </div>
        </template>
        <template v-slot:[`item.company_name`]="{ item }">
          <div style="font-size: 12px; padding: 0; width: 210px">
            {{ item.company_name }} - ({{ item.location_name }})
          </div>
        </template>
        <template v-slot:[`item.department`]="{ item }">
          <div style="font-size: 12px; padding: 0; width: 210px">
            {{ item.department.name }}
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div
            v-if="item.status !== 2"
            style="font-size: 12px; padding: 0; display: flex"
          >
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    icon
                    @click.stop="qrCode(item)"
                    x-small
                  >
                    <v-icon small color="indigo">mdi-qrcode</v-icon>
                  </v-btn>
                </template>
                <span>QR Code</span>
              </v-tooltip>
            </div>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    icon
                    color="indigo"
                    @click.stop="openUsageForm(item)"
                    x-small
                  >
                    <v-icon small>mdi-plus-box</v-icon>
                  </v-btn>
                </template>
                <span>Gunakan</span>
              </v-tooltip>
            </div>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    icon
                    color="indigo"
                    @click.stop="update(item)"
                    x-small
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </div>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    icon
                    color="red lighten-2"
                    @click.stop="remove(item)"
                    x-small
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ------------------------ Transfered lot ---------------------------------- -->
    <!-- <v-card
      v-if="lot !== null"
      flat
      class=" mx-auto"
      style="padding:0; width:99%; margin-top:20px; margin-bottom:10px;"
    >
      <v-toolbar-title class="overline">
        <p
          style="font-size:14px;margin:0; padding: 5px; font-weight:bold; color:indigo;text-align:center;"
        >
          Transfered LOT
        </p>
      </v-toolbar-title>
      <v-data-table
        fixed-header
        height="33vh"
        :headers="headers"
        class="elevation-1 mx-auto"
        style="width:100%; margin-bottom:10px; border:1px solid #e0e0e0;cursor:pointer;"
        :items-per-page="10"
      >
        <template v-slot:[`item.total`]>
          <div style="font-size:12px; padding: 0; display: flex; ">
            1
          </div>
        </template>
        <template v-slot:[`item.current_location_name`]="{ item }">
          <div style="font-size:12px; padding: 0; display: flex; ">
            {{ item.current_company_name }} - ({{ item.current_location_name }})
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div style="font-size:12px; padding: 0; display: flex; ">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    icon
                    @click.stop="qrCode(item)"
                  >
                    <v-icon color="indigo">mdi-qrcode</v-icon>
                  </v-btn>
                </template>
                <span>QR Code</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card> -->

    <line-save
      @loadPage="loadList"
      :detailLot="lot"
      :assetDetail="assetDetail"
    />
    <random-generate
      @loadPage="loadList"
      :detailLot="lot"
      :assetDetail="assetDetail"
    />
    <add-sequence
      @loadPage="loadList"
      :detailLot="lot"
      :assetDetail="assetDetail"
    />
    <qr-code :selectedLot="selected" />

    <usage-form
      @loadPage="loadList"
      :selectedLot="selectedLot"
      :assetDetail="assetDetail"
    />
    <div style="height: 0; overflow: hidden" v-if="form !== null">
      <v-dialog v-model="dialog" width="500">
        <v-form
          ref="entryForm"
          @submit.prevent="submit"
          style="position: relative"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Edit Lot
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Kode Lot
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-text-field
                      v-model="form.lot_no"
                      outlined
                      :rules="codeRules"
                    />
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div>
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Company
                      </p>

                      <v-autocomplete
                        v-model="form.company"
                        :items="dropdown.company"
                        item-text="name"
                        item-value="id"
                        return-object
                        outlined
                        dense
                        @change="companyWatcher"
                        style="margin: 0"
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div>
                      <p
                        class="text-left"
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Department
                      </p>

                      <v-autocomplete
                        v-model="form.department"
                        :items="dropdown.department"
                        item-text="name"
                        item-value="id"
                        return-object
                        outlined
                        dense
                        style="margin: 0"
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Qty
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-text-field
                      dense
                      v-model="form.qty"
                      outlined
                      min="0"
                      type="number"
                    />
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                color="error"
                text
                outlined
                @click="close"
                :loading="loading"
              >
                Batal
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                type="submit"
                text
                outlined
                :loading="loading"
              >
                Simpan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>

    <v-dialog v-model="usageDialog" min-width="500" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          LIST DOKUMEN PENGGUNAAN ASSET
        </v-card-title>

        <v-card-text class="d-flex justify-center align-center">
          <v-row style="">
            <v-col cols="12">
              <v-data-table
                :headers="usageListHeaders"
                :items="usageList"
                item-key="id"
                mobile-breakpoint="0"
                :items-per-page="100"
                class="text-caption"
                style="cursor: pointer"
                dense
                @click:row="openDetailUsage"
                hide-default-footer
              >
                <template v-slot:[`item.doc_no`]="{ item }">
                  <div :style="`width:120px; font-size:12px;`">
                    {{ item.doc_no }}
                  </div>
                </template>
                <template v-slot:[`item.usage_location`]="{ item }">
                  <div :style="`width:120px; font-size:12px;`">
                    {{ item.usage_location }}
                  </div>
                </template>
                <template v-slot:[`item.planned_date`]="{ item }">
                  <div :style="`width:90px; font-size:12px;`">
                    {{ item.planned_date }}
                  </div>
                </template>
                <template v-slot:[`item.qty_used`]="{ item }">
                  <div :style="`width:90px; font-size:12px;`">
                    {{ item.qty_used }}
                  </div>
                </template>
                <template v-slot:[`item.file`]="{ item }">
                  <div
                    v-for="(items, index) in item.file"
                    :key="index"
                    :style="`font-size:12px;`"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="blue darken-2"
                          style="margin: 0"
                          small
                          @click="openImageUsage(items.file)"
                          :disabled="!item.file"
                        >
                          mdi-image
                        </v-icon>
                      </template>
                      <span>Lihat Foto ({{ items.subject }})</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <div
                    :style="`text-transform:uppercase; font-size:12px; font-weight:bolder; color:${usageStatusColor(
                      item.status
                    )};`"
                  >
                    {{ usageStatusName(item.status) }}
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            style="position: absolute; top: 5px; right: 5px"
            color="error"
            icon
            small
            @click="closeUsageDialog"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import axios from 'axios'
import buildType from '../../../../services/buildType'
import { mapMutations } from 'vuex'
export default {
  props: ['lot', 'assetDetail'],
  components: {
    // QrCode: () => import('./LotQrcode'),
    // QrCode: () => import('./QRCode'),
    // QrCode: () => import('./LotQrcodeV2'),
    QrCode: () => import('./QRvuehtml2pdf'),
    LineSave: () => import('./LineSave'),
    RandomGenerate: () => import('./RandomGenerate'),
    AddSequence: () => import('./AddSequence'),
    UsageForm: () => import('./UsageForm')
  },
  data() {
    return {
      asset: buildType.apiURL('asset'),
      hrsApi: buildType.apiURL('hrs'),
      eSanqua: buildType.apiURL('esanqua'),
      headers: [
        {
          text: 'Aksi',
          value: 'action',
          align: 'left',
          sortable: false
        },
        { text: 'Lot', value: 'lot_no', align: 'left', sortable: false },
        { text: 'Tersedia', value: 'qty', align: 'left', sortable: false },
        {
          text: 'Digunakan',
          value: 'qty_used',
          align: 'left',
          sortable: false
        },
        {
          text: 'Lokasi asal',
          value: 'company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Department',
          value: 'department_name',
          align: 'left',
          sortable: false
        },
        // {
        //   text: 'location',
        //   value: 'location_name',
        //   align: 'left',
        //   sortable: false
        // },
        {
          text: 'Lokasi saat ini',
          value: 'current_location_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Dibuat',
          value: 'created_at',
          align: 'left',
          sortable: false
        }
        // {
        //   text: 'Purchased',
        //   value: 'purchase_date',
        //   align: 'left',
        //   sortable: false
        // },
      ],
      selected: null,
      form: null,
      dialog: false,
      loading: false,
      codeRules: [],
      dropdown: {
        department: [],
        company: []
      },
      selectedLot: null,
      usageList: [],
      usageDialog: false,
      usageListHeaders: []
    }
  },
  computed: {
    // ...mapGetters(['getDropdownDepartment'])
  },
  methods: {
    ...mapMutations(['setAssetLotCompanyId']),
    // ...mapActions(['dropdownDepartment']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    openImageUsage(pItem) {
      console.log(pItem)
      if (pItem) {
        window.open(pItem, '_blank')
      } else {
        this.showMsgDialog('warning', 'Belum ada foto', false)
      }
    },
    closeUsageDialog() {
      this.usageDialog = false
      setTimeout(() => {
        this.usageList = []
        this.usageListHeaders = []
      }, 100)
    },
    openUsageList(xItem) {
      this.usageListHeaders = [
        {
          text: 'No. Dokumen',
          value: 'doc_no',
          align: 'left',
          sortable: true
        },
        {
          text: 'Digunakan',
          value: 'qty_used',
          align: 'left',
          sortable: false
        },
        {
          text: 'Lokasi',
          value: 'usage_location',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Digunakan',
          value: 'planned_date',
          align: 'left',
          sortable: true
        },
        {
          text: 'Photo',
          value: 'file',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        }
      ]
      this.initTabelUsage(xItem)
    },
    initTabelUsage(xItem) {
      const apiLink = `${this.asset}usage/list?keyword=&lot_id=${xItem.id}&order_by=id&order_type=desc&offset=0&limit=all&status=2`
      axios
        .get(apiLink)
        .then((res) => {
          console.log(res.data)
          if (res.data.status_code == '00') {
            this.usageList = res.data.data
            setTimeout(() => {
              this.usageDialog = true
            }, 100)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    xFlag = true
                  }
                } else {
                  xFlag = true
                }
              } else {
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.showMsgDialog('warning', err.message, 'false')
        })
    },
    openDetailUsage(xItem) {
      console.log('openDetailUsage>>>', xItem)
      window.open(`/asset-management/detail-pemakaian/${xItem.id}`, '_blank')
    },
    usageStatusName(val) {
      switch (val) {
        case -2:
          return 'Canceled'
        case -1:
          return 'Rejected'
        case 0:
          return 'Draft'
        case 1:
          return 'Waiting'
        case 2:
          return 'Approved'

        default:
          return 'null'
      }
    },
    usageStatusColor(val) {
      switch (val) {
        case -2:
          return 'red'
        case -1:
          return 'red'
        case 0:
          return 'blue'
        case 1:
          return 'orange'
        case 2:
          return 'green'

        default:
          return 'null'
      }
    },
    addLine() {
      setTimeout(() => {
        document.getElementById('addLot').click()
      }, 300)
    },
    randomGenerate() {
      setTimeout(() => {
        document.getElementById('randomGenerateLot').click()
      }, 300)
    },
    openUsageForm(item) {
      this.selectedLot = item
      setTimeout(() => {
        document.getElementById('usageFormAdd').click()
      }, 300)
    },
    addSequence() {
      setTimeout(() => {
        document.getElementById('addSequenceLot').click()
      }, 300)
    },
    loadList() {
      this.$emit('loadPage')
    },
    remove(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          axios
            .delete(`${this.asset}asset/lot/delete/${pItem.id}`)
            .then((res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, 'false')
              } else {
              }
              this.loadList()
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog('error', err, 'false')
            })
        } else {
          this.actionValue = 0
        }
      })
    },
    rowClick(pItem) {
      this.setAssetLotCompanyId(pItem.company_id)
      setTimeout(() => {
        this.$router.push(
          `/asset-management/aset-kepemilikan/lot/detail/${pItem.id}`
        )
      }, 300)
    },
    qrCode(pItem) {
      const item = pItem
      const name = item.name.toUpperCase()
      const arrName = name.split('')
      // console.log(arrName)
      for (let i = 0; i < arrName.length; i++) {
        if (arrName[i] === '-') {
          arrName[i] = arrName[i] + '&NoBreak;'
        }
      }
      const newName = arrName.join('')
      item.name = newName
      console.log(item)
      this.selected = item
      setTimeout(() => {
        document.getElementById('lotQrcode').click()
      }, 300)
    },
    async update(pItem) {
      console.log('update lot>>>', pItem)
      this.form = {
        act: 'update',
        id: pItem.id,
        lot_no: pItem.lot_no,
        qty: pItem.qty,
        department: null,
        company: null
      }
      if (pItem.department_id != null) {
        Object.assign(this.form, {
          department: {
            id: pItem.department_id,
            name: pItem.department_name
          }
        })
      }
      if (pItem.company_id != null) {
        Object.assign(this.form, {
          company: {
            id: pItem.company_id,
            name: pItem.company_name
          }
        })
        setTimeout(() => {
          this.getDropdownDepartment(this.form.company)
        }, 100)
      }
      setTimeout(() => {
        this.getDropdownCompany()
        this.dialog = true
      }, 300)
    },
    companyWatcher(val) {
      if (val != null) {
        this.getDropdownDepartment(val)
      } else {
        this.dropdown.department = []
      }
    },
    async getDropdownCompany() {
      console.log('get dropdown company>>>')
      this.dropdown.company = []
      await axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          console.log('dropdown company>>>', res)

          if (res.data.status_code == '00') {
            this.dropdown.company = res.data.data
          } else {
            this.dropdown.company = []
          }
        })
        .catch((error) => {
          this.dropdown.company = []
          console.log(error)
        })
    },
    async getDropdownDepartment(val) {
      console.log('getDropdownDepartment>>>>', val)
      this.dropdown.department = []
      await axios
        .get(
          `${this.hrsApi}master/universal/department/dropdown?filter=[{"company_id":${val.id}}]`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropdown.department = res.data.data
          } else {
            this.dropdown.department = []
          }
        })
        .catch((error) => {
          this.dropdown.department = []
          console.log(error)
        })
    },

    submit() {
      this.codeRules = [(v) => !!v || 'Code is required']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      this.save(this.form)
    },
    save(form) {
      if (form.company == null || form.department == null) {
        this.showMsgDialog(
          'error',
          'Company or Department cannot be empty',
          false
        )
        return
      }
      console.log('form lot_no>>>>', form)
      // var idCompany = Number(form.lot_no.split('.')[0])
      var idCompany = form.company.id
      console.log('Check id from lot_no>>>>', idCompany)
      // if (!/^\d+$/.test(idCompany)) {
      // return this.showMsgDialog(
      //   'warning',
      //   'Invalid company id, please contact admin',
      //   false
      // )
      // }
      // const name = this.getCompany(idCompany)
      const newform = {
        act: 'update',
        department_id: form.department.id,
        department_name: form.department.name,
        company_id: idCompany,
        company_name: form.company.name,
        id: form.id,
        lot_no: form.lot_no,
        qty: form.qty
      }
      console.log('Save lot', newform)
      this.loading = true
      axios
        .post(`${this.asset}asset/lot/update`, newform)
        .then((res) => {
          if (res.data.status_code == '00') {
            setTimeout(() => {
              this.showMsgDialog('success', res.data.status_msg, false)
              this.close()
            }, 1000)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'error',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }

            this.loading = false
          }
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    close() {
      this.loading = false
      this.dialog = false
      this.form = null
      this.loadList()
    },
    lotStatus(pId) {
      switch (pId) {
        case -1:
          return 'Gone'
        case 1:
          return 'Available'
        case 2:
          return 'Sold'
      }
    },
    statusColor(pId) {
      switch (pId) {
        case -1:
          return 'red'
        case 1:
          return 'Green'

        case 2:
          return 'orange'
      }
    },
    convertDate(val) {
      const raw = val
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
